import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';
import SoulBalmLogo from '../components/SoulBalmLogo';
import { useState } from 'react';

function StarField() {
  const [stars] = useState(() =>
    Array.from({ length: 60 }, (_, i) => ({
      id: i, x: Math.random() * 100, y: Math.random() * 100,
      size: Math.random() * 2 + 0.5, delay: Math.random() * 5, duration: Math.random() * 3 + 2,
    }))
  );
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {stars.map(s => (
        <motion.div key={s.id} className="absolute rounded-full bg-[#FFFFF0]"
          style={{ left: `${s.x}%`, top: `${s.y}%`, width: s.size, height: s.size }}
          animate={{ opacity: [0.1, 0.8, 0.1] }}
          transition={{ duration: s.duration, repeat: Infinity, delay: s.delay, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
}

export default function LandingPage() {
  return (
    <div className="min-h-screen relative flex flex-col items-center justify-center overflow-hidden" data-testid="landing-page">
      <div className="absolute inset-0 bg-[#070A1A]" />
      <div className="absolute inset-0 mystic-gradient" />
      <StarField />
      <div className="relative z-10 flex flex-col items-center text-center px-6 max-w-2xl">
        <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.2, ease: "easeOut" }} className="mb-8">
          <SoulBalmLogo size={96} />
        </motion.div>
        <motion.h1 className="font-['Playfair_Display'] text-5xl sm:text-6xl lg:text-7xl font-bold text-[#FFFFF0] tracking-tight leading-none"
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.3 }} data-testid="landing-title">
          TAROT ROOM
        </motion.h1>
        <motion.p className="text-sm text-[#D4AF37] tracking-[0.25em] uppercase mt-3 font-light"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.6 }} data-testid="landing-subtitle">
          by The Soul Balm
        </motion.p>
        <motion.p className="text-base md:text-lg text-[#BDB2C4] mt-4 font-['Playfair_Display'] italic"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.9 }} data-testid="landing-tagline">
          Your Personal Space to Find All Your Answers...
        </motion.p>
        <motion.div className="mt-12 flex flex-col items-center gap-4"
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 1.2 }}>
          <Link to="/login" data-testid="landing-enter-btn"
            className="btn-primary flex items-center gap-3 text-base px-10 py-4">
            <Sparkles size={18} strokeWidth={1.5} />
            Enter the Room
            <ArrowRight size={18} strokeWidth={1.5} />
          </Link>
          <Link to="/signup" data-testid="landing-signup-link"
            className="text-sm text-[#BDB2C4] hover:text-[#D4AF37] transition-colors duration-300 underline underline-offset-4">
            I am a First Time User
          </Link>
        </motion.div>
        <motion.p className="text-xs text-[#BDB2C4]/40 mt-16 tracking-wider" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2 }}>
          A sacred space for self-reflection and healing
        </motion.p>
      </div>
    </div>
  );
}
